import { computed } from 'vue';
import { defineStore } from 'pinia'
//import { postechPileSchema, customerSchema } from '@/types/types'
import * as yup from 'yup'
import { useStoreSyncer } from '@/composables/Store-syncer';


//for closeout, piles fields are required:
const postechCloseoutPileSchema = yup.object({
  pileType: yup.string().defined(),
  torqueMin: yup
    .number()
    .min(0)
    .integer()
    .transform((curr, orig) => (orig === '' ? null : curr)),
  torqueMax: yup
    .number()
    .min(0)
    .integer()
    .nullable()
    .transform((curr, orig) => (orig === '' ? null : curr)),
  pileCount: yup.number().positive().integer().defined()
})


export const usePileStore = defineStore('piles', () => {
  //const cache = useCacheStore();
  const { fetchAll, update, remove, create, allItems, loading, error } = useStoreSyncer('/piles', 'piles'); 

  const allPiles = computed(()=>{
  // return cache.getFromCache('postech') || [];
   return allItems.value;
  })

//  const tableData = computed(()=>{
//    const data = allItems.value;
//    return data;
/*
    console.log(".. parseTableData for Postech...");
    //map array to show customer fields
   //const mapped = Promise.all(data.map(async (postech) => {
    const mapped = data.map(postech =>{
    //inv.customerName = inv.customer.invoiceName;
    //console.log('... piles = ' + JSON.stringify(postech.piles))
    const temp = JSON.parse(JSON.stringify(postech));
    try{
      const totalPiles = sumField(postech.piles, 'pileCount')
      temp.pileCount = totalPiles
    }catch(error){
      console.error("..trapped error on totalPiles parseTable = " + error);
      console.log("..postech = " + postech.id);
    }
    //const totalPiles = 99;
    let installer;
    try{
     installer = postech.installer.invoiceName;
     console.log(".....installer.invoiceName = " + installer);
     temp.installer = installer;
    }catch(error){
      console.error("..trapped error Postech-table.setPostechs() error fetching postech on installer: " + error);
      console.error("...postech obj = " + JSON.stringify(postech));
      temp.installer = "undefined in backend";
    }
    return temp
  })

  return mapped;*/
//  })
 
  /**
   * Force fetch from backend
   */
  async function fetchAllPiles(){
    console.log("piles store fetching all from api or cache...")
    return await fetchAll();
  }

  async function getById(id: number) {
    console.log('pile store fetching by id ' + id)
    try{
      return allPiles.value.find(pile =>{
        return pile.id === id;
      });
    }catch (error){
      console.log("error on pile store.getById");
    }
  }


  /**
   * update a single postech
   * @return
   *
  async function updatePile(pile: PileType) {
    console.log('pile store.updatePile()...')
    return await update(pile, existingPostechSchema, 'postech');
  }*/

  /**
   * delete a Postech
   *
  async function deletePostech(id: Number) {
    console.log('postech store deletePostech for id : ' + id)
    return await remove(id);
  }*/

  /**
   * create a new Postech entr
   * backend will assign the postechId and return it
   *
  async function createPostech(postech: Postech) {
    console.log('postech store createPostech : ' + JSON.stringify(postech))
    console.log('validating object : ' + JSON.stringify(postech))
    postech.installerId = postech.installer.id
    return await create(postech, newPostechSchema, 'postech');
  }*/



  return {
    allPiles,
    fetchAllPiles,
    getById,
   /* getAllPileTypes,
    getProjectPostechs,
    updatePostech,
    deletePostech,
    createPostech,
    createCloseout,
    loading,
    tableData*/
  }
})

